import { signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { SearchMinLength } from '../../../../common/enums/search-min-length';
import { debounceTime, skip, Subject, takeUntil } from 'rxjs';
import { Meta } from '../../../../common/models/api-response.model';
import { Option } from '../../../../common/models/option.model';

export abstract class BaseCardList {
  isCardListLoading = signal<boolean>(false);
  cardListCurrentPage = signal<number>(1);
  cardListTotalPages = signal<number>(1);
  cardListTotalItems = signal<number>(0);
  assignedList = signal<Option[]>([]);
  searchTerm = signal<string>('');
  isMoreThanThreeCharacters = signal<boolean>(false);
  minSearchLength = signal<number>(SearchMinLength.length);
  protected readonly searchTerm$ = toObservable(this.searchTerm);
  destroy$ = new Subject<void>();

  searchTermWrapper() {
    this.searchTerm$
      .pipe(skip(1), debounceTime(600), takeUntil(this.destroy$))
      .subscribe(term => {
        this.handleSearchTerm(term);
      });
  }

  handleSearchTerm(term: string): void {
    this.cardListCurrentPage.set(1);
    if (term.length >= this.minSearchLength()) {
      this.isMoreThanThreeCharacters.set(true);
      this.getCardList(term);
    } else if (
      this.isMoreThanThreeCharacters() &&
      term.length < this.minSearchLength()
    ) {
      this.isMoreThanThreeCharacters.set(false);
      this.getCardList();
    }
  }

  onSearchTermChange(term: string) {
    this.searchTerm.set(term);
  }

  handleCardListResponse(list: Option[], meta: Meta) {
    this.assignedList.set(list);
    this.cardListTotalItems.set(meta.total);
    this.cardListTotalPages.set(meta.last_page);
    this.isCardListLoading.set(false);
  }

  filterCards() {
    if (this.searchTerm().length >= SearchMinLength.length) {
      const searchValue = this.searchTerm().toLowerCase();
      const cards = this.assignedList().filter(card =>
        card.label.toLowerCase().includes(searchValue)
      );
      this.assignedList.set(cards);
    } else {
      this.assignedList.set(this.assignedList());
    }
  }

  handleCardListPagination(pageNumber: number) {
    this.cardListCurrentPage.set(pageNumber);
    this.getCardList();
  }

  protected abstract getCardList(searchName?: string): void;
}
